import { setCurrentUser } from "utils/utils";
import requestInstance from "./Request";
import { API_ENDPOINT } from "./Api";

let env = process.env.REACT_APP_B2B_API_BASE_URL;

//Profile Service
export const profileApi = async (payload) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.profile.api}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

//Update Profile service
export const updateProfileApi = async (data) => {
  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.profile.api}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};
